module.exports = __webpack_public_path__ + "static/media/35.3238c1ba.jpg";